import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Box, Typography, Input, Alert } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import VideocamIcon from '@mui/icons-material/Videocam';
import ImageIcon from '@mui/icons-material/Image';
import client from '../../client';
import Navbar from '../../components/Navbar';
import slugify from '../../utils/slugify';

const Add = () => {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [core, setCore] = useState('');
  const [box, setBox] = useState(null);
  const [logo, setLogo] = useState(null);
  const [snap, setSnap] = useState(null); // Novo estado para o snap
  const [titleImg, setTitleImg] = useState(null);
  const [video, setVideo] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState('');

  const handlePasswordSubmit = (event) => {
    event.preventDefault();
    if (password === '290304') {
      setShowForm(true);
      setError('');
    } else {
      setError('Senha incorreta.');
      setShowForm(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    let boxAsset = null;
    if (box) {
      try {
        const uploadedCover = await client.assets.upload('image', box, {
          contentType: box.type,
          filename: box.name,
        });
        console.log('Resposta do upload da capa:', uploadedCover);
        boxAsset = { _type: 'reference', _ref: uploadedCover._id };
      } catch (error) {
        console.error('Erro ao fazer upload da capa:', error);
        setIsSubmitting(false);
        return;
      }
    }

    let fileAsset = null;
    if (file) {
      try {
        const uploadedFile = await client.assets.upload('file', file, {
          contentType: file.type,
          filename: file.name,
        });
        console.log('Resposta do upload do arquivo:', uploadedFile);
        fileAsset = { _type: 'reference', _ref: uploadedFile._id };
      } catch (error) {
        console.error('Erro ao fazer upload do arquivo:', error);
        setIsSubmitting(false);
        return;
      }
    }

    let logoAsset = null;
    if (logo) {
      try {
        const uploadedLogo = await client.assets.upload('image', logo, {
          contentType: logo.type,
          filename: logo.name,
        });
        console.log('Resposta do upload do logo:', uploadedLogo);
        logoAsset = { _type: 'reference', _ref: uploadedLogo._id };
      } catch (error) {
        console.error('Erro ao fazer upload do logo:', error);
        setIsSubmitting(false);
        return;
      }
    }

    let snapAsset = null;
    if (snap) {
      try {
        const uploadedSnap = await client.assets.upload('image', snap, {
          contentType: snap.type,
          filename: snap.name,
        });
        console.log('Resposta do upload do snap:', uploadedSnap);
        snapAsset = { _type: 'reference', _ref: uploadedSnap._id };
      } catch (error) {
        console.error('Erro ao fazer upload do snap:', error);
        setIsSubmitting(false);
        return;
      }
    }

    let titleAsset = null;
    if (titleImg) {
      try {
        const uploadedTitle = await client.assets.upload('image', titleImg, {
          contentType: titleImg.type,
          filename: titleImg.name,
        });
        console.log('Resposta do upload da imagem do título:', uploadedTitle);
        titleAsset = { _type: 'reference', _ref: uploadedTitle._id };
      } catch (error) {
        console.error('Erro ao fazer upload da imagem do título:', error);
        setIsSubmitting(false);
        return;
      }
    }

    let videoAsset = null;
    if (video) {
      try {
        const uploadedVideo = await client.assets.upload('file', video, {
          contentType: video.type,
          filename: video.name,
        });
        console.log('Resposta do upload do vídeo:', uploadedVideo);
        videoAsset = { _type: 'reference', _ref: uploadedVideo._id };
      } catch (error) {
        console.error('Erro ao fazer upload do vídeo:', error);
        setIsSubmitting(false);
        return;
      }
    }

    const doc = {
      _type: 'game',
      name: name,
      core: core,
      box: boxAsset ? { _type: 'image', asset: boxAsset } : undefined,
      file: fileAsset ? { _type: 'file', asset: fileAsset } : undefined,
      logo: logoAsset ? { _type: 'image', asset: logoAsset } : undefined,
      snap: snapAsset ? { _type: 'image', asset: snapAsset } : undefined, // Adicionado o campo snap
      title: titleAsset ? { _type: 'image', asset: titleAsset } : undefined,
      video: videoAsset ? { _type: 'file', asset: videoAsset } : undefined,
      slug: {
        _type: 'slug',
        current: slugify(name),
      },
    };

    console.log('Documento sendo enviado:', doc); // Para debug

    try {
      const createdDocument = await client.create(doc);
      console.log('Jogo adicionado com sucesso! ID:', createdDocument._id);

      const generatedSlug = slugify(name);
      navigate(`/${core}/${generatedSlug}`); // Redireciona imediatamente com o slug gerado

    } catch (error) {
      console.error('Erro ao adicionar jogo:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBoxChange = (event) => {
    const selectedBox = event.target.files[0];
    setBox(selectedBox);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleLogoChange = (event) => {
    const selectedLogo = event.target.files[0];
    setLogo(selectedLogo);
  };

  const handleSnapChange = (event) => { // Nova função para o snap
    const selectedSnap = event.target.files[0];
    setSnap(selectedSnap);
  };

  const handleTitleChange = (event) => {
    const selectedTitle = event.target.files[0];
    setTitleImg(selectedTitle);
  };

  const handleVideoChange = (event) => {
    const selectedVideo = event.target.files[0];
    setVideo(selectedVideo);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
          pb: '96px',
        }}
      >
        {!showForm ? (
          <form onSubmit={handlePasswordSubmit} noValidate style={{ width: '100%', maxWidth: 256 }}>
            <TextField
              placeholder="Senha"
              type="password"
              fullWidth
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={{
                mt: '0!important'
              }}
            />
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Entrar
            </Button>
            {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
          </form>
        ) : (
          <>
            <Typography variant="h4" component="h2" gutterBottom>
              Adicionar
            </Typography>

            <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 320 }}>
              <TextField
                label="Core"
                fullWidth
                margin="normal"
                value={core}
                onChange={(e) => setCore(e.target.value)}
                required
              />
              <TextField
                label="Nome"
                fullWidth
                margin="normal"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
              <Box sx={{ mt: 2 }}>
                <label htmlFor="file-upload">
                  <Input
                    style={{ display: 'none' }}
                    id="file-upload"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<AttachFileIcon />}
                  >
                    {file ? file.name : 'Selecionar ROM'}
                  </Button>
                </label>
              </Box>
              <Box sx={{ mt: 2 }}>
                <label htmlFor="box-upload">
                  <Input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="box-upload"
                    type="file"
                    onChange={handleBoxChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<ImageIcon />}
                  >
                    {box ? box.name : 'Selecionar Box'}
                  </Button>
                </label>
              </Box>
              <Box sx={{ mt: 2 }}>
                <label htmlFor="logo-upload">
                  <Input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="logo-upload"
                    type="file"
                    onChange={handleLogoChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<ImageIcon />}
                  >
                    {logo ? logo.name : 'Selecionar Logo'}
                  </Button>
                </label>
              </Box>
              <Box sx={{ mt: 2 }}>
                <label htmlFor="snap-upload">
                  <Input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="snap-upload"
                    type="file"
                    onChange={handleSnapChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<ImageIcon />}
                  >
                    {snap ? snap.name : 'Selecionar Snap'}
                  </Button>
                </label>
              </Box>
              <Box sx={{ mt: 2 }}>
                <label htmlFor="title-upload">
                  <Input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="title-upload"
                    type="file"
                    onChange={handleTitleChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<ImageIcon />}
                  >
                    {titleImg ? titleImg.name : 'Selecionar Título'}
                  </Button>
                </label>
              </Box>
              <Box sx={{ mt: 2 }}>
                <label htmlFor="video-upload">
                  <Input
                    accept="video/mp4, video/webm, video/ogg"
                    style={{ display: 'none' }}
                    id="video-upload"
                    type="file"
                    onChange={handleVideoChange}
                  />
                  <Button
                    variant="outlined"
                    component="span"
                    fullWidth
                    startIcon={<VideocamIcon />}
                  >
                    {video ? video.name : 'Selecionar Vídeo'}
                  </Button>
                </label>
              </Box>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ my: 2 }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Adicionando...' : 'Adicionar'}
              </Button>
            </form>
          </>
        )}
      </Box>
      <Navbar />
    </>
  );
};

export default Add;